(function (window, undefined) {
  'use strict';

  angular.module('cbl.finanza.mf').service('EstrattoContoTableSrvc', [
    '$http',
    '$q',
    'FinMessaggiFctr',
    'FIN_CONSTANTS',
    function ($http, $q, messaggiFctr, CONSTANTS) {
      var codiceCedola = 'CED';
      var codiceRimborsi = 'RIMB';
      var codiceDividendi = 'DIV';

      var self = this;

      this.getTable = function (data, filter) {
        var result = {
          totaleCedole: 0,
          totaleRimborsi: 0,
          totaleDividendi: 0,
          listePerScadenza: {}
        };

        if (!data) {
          return result;
        }

        data = data.filter(function (item) {
          return (
            (!filter.strumentiUS || item.strumentoUS === 'Y') &&
            ((filter.cedole && item.codiceMovimento === codiceCedola) ||
              (filter.rimborsi && item.codiceMovimento === codiceRimborsi) ||
              (filter.dividendi && item.codiceMovimento === codiceDividendi))
          );
        });

        data.forEach(function (item) {
          if (!result.listePerScadenza[item.scadenza]) {
            result.listePerScadenza[item.scadenza] = { rows: [], totale: 0 };
          }
          var totale = item.importoNettoEuro;
          result.listePerScadenza[item.scadenza].rows.push(item);
          result.listePerScadenza[item.scadenza].totale =
            result.listePerScadenza[item.scadenza].totale + totale;
          switch (item.codiceMovimento) {
            case codiceCedola:
              result.totaleCedole += totale;
              break;
            case codiceDividendi:
              result.totaleDividendi += totale;
              break;
            case codiceRimborsi:
              result.totaleRimborsi += totale;
              break;
          }
        });

        return result;
      };

      this.excel = function (data, filter) {
        var defer = $q.defer();
        var input = self.getTable(data, filter);

        $http
          .post(
            CONSTANTS.REST_ROOT + CONSTANTS.REST.DOSSIER + 'cashflow',
            input
          )
          .then(function (response) {
            if (messaggiFctr.processaResponse(response)) {
              return;
            }
            self.download(response.data.result);
          })
          .finally(function () {
            defer.resolve(null);
          });
        return defer.promise;
      };

      this.download = function (allegato) {
        var byteArrays = self.b64toByteArrays(allegato);
        var blobType =
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        var fileName = 'export_excel.xlsx';

        var isChromium = window.chrome,
          winNav = window.navigator,
          vendorName = winNav.vendor,
          isOpera = winNav.userAgent.indexOf('OPR') > -1,
          isIEedge = winNav.userAgent.indexOf('Edge') > -1,
          isIOSChrome = winNav.userAgent.match('CriOS');

        if (
          isIOSChrome ||
          (isChromium !== null &&
            isChromium !== undefined &&
            vendorName === 'Google Inc.' &&
            isOpera == false &&
            isIEedge == false)
        ) {
          // è Google Chrome
          var blob = new Blob(byteArrays, { type: blobType });
          var blobUrl = URL.createObjectURL(blob);
          // soluzione per costringere chrome a mostrare nome ed estensione del file
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.style = 'display: none';
          a.href = blobUrl;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(fileUrl);
          a.parentNode.removeChild(a);
        } else {
          // non è Google Chrome
          // Blob per internet explorer
          if (navigator.msSaveOrOpenBlob) {
            var blob = new Blob(byteArrays, { type: blobType });
            var blobUrl = URL.createObjectURL(blob);
            navigator.msSaveOrOpenBlob(blob, fileName);
          } // File per altri browser
          else {
            var file = new File(byteArrays, fileName, { type: blobType });
            var fileUrl = URL.createObjectURL(file);
            window.open(fileUrl);
          }
        }
      };

      this.b64toByteArrays = function (b64Data, sliceSize) {
        sliceSize = sliceSize || 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (
          var offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }
        return byteArrays;
      };
    }
  ]);
})(window);



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/estrattoconto/estrattoconto.table.srvc.js
 ** module id = 55
 ** module chunks = 1
 **/